import React, { useEffect, useState } from "react";
import {  
  INVOICE_TRACKING_HOSTNAME
} from "../../../../common-utilities/utils/end-points";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { getHeaderConfig, FIELD_TYPES } from "./helper";
import MuiTable from "../../../../common-utilities/core/mui-table";
import { Autocomplete, Button, TextField } from "@mui/material";
import CustomModal from "../../../../common-utilities/core/modal";
import "./index.scss";
import ConfirmModal from "../../../../common-utilities/core/confirm-modal";
import { toast } from "react-toastify";
import { REST_URLS } from "../../../../common-utilities/utils/end-points/invoice-tracking";

const ItemList = ({}) => {
  const [budgetModal, setBudgetModal] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [budgetList, setBudgetList] = useState([]);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 100
  });
  const [deleteDetails, setDeleteDetails] = useState(null);
  const [inputUnitValue, setInputUnitValue] = useState("");

  useEffect(() => {
    loadData(filters);
  }, []);

  const loadData = (filters) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_FIELDS}`,
      null,
      filters
    )
      .then((response) => {
        if (response.message) {
        } else {
          setBudgetList(response || {});
        }
      })
      .catch((err) => {});
  };

  const onSave = () => {
    const { fieldType = {} } = formDetails;
    let payload = {
      title: formDetails.title
    };

    if (fieldType?.value) {
      payload.fieldType = fieldType?.value;
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_FIELDS}`,
      payload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message, { autoClose: 2000 });
        } else {
          setBudgetModal(false);
          loadData(filters);
          setFormDetails({});
        }
      })
      .catch((err) => {});
  };

  const onUpdate = () => {
    const { fieldType = {} } = formDetails;
    let payload = {
      title: formDetails.title
    };

    if (fieldType?.value) {
      payload.fieldType = fieldType?.value;
    }

    invokeApi(
      HTTP_METHODS.PUT,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_FIELDS}/${formDetails.id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
        } else {
          setBudgetModal(false);
          loadData(filters);
          setFormDetails({});
        }
      })
      .catch((err) => {});
  };

  const onInputChange = (event) => {
    setFormDetails({
      ...formDetails,
      [event.target.name]: event.target.value
    });
  };

  const editVendor = (data) => {    
    setBudgetModal(true);
    const fieldType =
      FIELD_TYPES.find((e) => e.value === data.fieldType) || null;
    setInputUnitValue(fieldType?.name);
    setFormDetails({ ...data, fieldType });
  };

  const onDelete = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_FIELDS}/${deleteDetails.id}`
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message, { autoClose: 2000 });
          return;
        }
        loadData(filters);
        setDeleteDetails(null);
      })
      .catch((err) => {});
  };

  return (
    <div className='item-list'>
      <div className='itl-header-section'>
        <div className='left-container'></div>
        <div className='left-container'>
          <Button variant='outlined' onClick={() => setBudgetModal(true)}>
            Create
          </Button>
        </div>
      </div>
      <MuiTable
        columnsList={getHeaderConfig(editVendor, setDeleteDetails)}
        dataList={budgetList.results || []}
        filters={filters}
        pageCount={budgetList.totalPages}
        onChange={(page) => {
          setFilters({
            ...filters,
            page
          });
          loadData({
            ...filters,
            page
          });
        }}
      />

      {budgetModal && (
        <CustomModal
          title={formDetails.id ? "Update Item" : "Create Item"}
          disabledOutsideClick={true}
          onClose={() => {
            setBudgetModal(false);
            setFormDetails({});
          }}
        >
          <div className='create-form'>
            <TextField
              value={formDetails.title || ""}
              onChange={onInputChange}
              size='small'
              name='title'
              label='Title'
              fullWidth
            />

            <Autocomplete
              options={FIELD_TYPES}
              value={formDetails.fieldType || ""}
              renderInput={(params) => (
                <TextField {...params} size='small' label='Field Type' />
              )}
              inputValue={inputUnitValue}
              onInputChange={(event, newInputValue) => {
                if (event) {
                  setInputUnitValue(newInputValue);
                }
              }}
              onChange={(e, val) => {
                setFormDetails({
                  ...formDetails,
                  fieldType: val
                });
              }}
            />

            {formDetails.id ? (
              <Button fullWidth variant='contained' onClick={onUpdate}>
                Update
              </Button>
            ) : (
              <Button fullWidth variant='contained' onClick={onSave}>
                Create
              </Button>
            )}
          </div>
        </CustomModal>
      )}
      {deleteDetails && (
        <ConfirmModal onYes={onDelete} onNo={() => setDeleteDetails(null)} />
      )}
    </div>
  );
};

export default ItemList;
